import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getUserGroupByUserId = (userId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.PROFILE.GET_USER_GROUP_BY_USERID(userId)
  );
};

export default getUserGroupByUserId;
